import { Link } from "react-router-dom";
import MainImageSlider from "../components/MainImageSlider";
import ImageSlider from "../components/ImageSlider";
import TextSlider from '../components/TextSlider';
import { ArrowRightIcon } from "lucide-react";


// ====== Define your data here ======
const data = [
  {
    title: "Watch Tower",
    images: ["/images/watchtowers/watchtower1.jpg"],
    summary:
      "On the dawn of the set day, I was caught up in the Visions of God and I received an Oracle from the Spirit of God for the Comfort and Victory of the Saints, I saw a vision where a group of brethren were on a journey to a glorious city. The way to the city was full of Light, but on both sides of the way there was a great cloud of Darkness. This journey was plagued with all forms of...",
    link: "/watchTower",
  },
  {
    title: "Ancient Scrolls",
    images: ["/images/Ancientscrolls/ancientscroll1.jpg"],
    summary:
      "Coming soon...",
    link: "/AncientScrolls",
  },
  {
    title: "Covenant Partnership",
    images: ["/images/partnerships/partnership1.jpg"],
    summary:
      "The Lord Jesus, through a Divine encounter, commanded the Man of God to win 1 million souls, Take them from darkness into the Light, keep them in the Light and Teach them how to Walk in the Light. The Man of God has wholeheartedly committed himself to that Heavenly vision by planting churches across the nations, holding crusades, organizing outreach programs, and sending...",
    link: "/CovenantPartnership",
  },
  {
    title: "Voice Of Glory",
    images: ["/images/Voiceofglory/voiceofglory1.png"],
    summary:
      "Coming soon...",
    link: "/VoiceOfGlory",
  },
  {
    title: "I Testify",
    images: ["/images/itestify/Itestify1.jpg"],
    summary:
      "Coming soon...",
    link: "/ITestify",
  },
  {
    title: "I Prophecy",
    images: ["/images/iprophecy/Iprophecy1.jpg"],
    summary:
      "Coming soon...",
    link: "/IProphecy",
  },
];

const SixLinksGrid = () => {


  const firstGroup = data.slice(0, 2);  // first 2
  const secondGroup = data.slice(2, 4); // next 2
  const extraItems = data.slice(4);     // remaining 2

   const Mainslides = [
    {
        image: "/images/vips/vip0.jpg",
        title: "Psalm 118:24",
        description:
            "This is the day which the LORD hath made; we will rejoice and be glad in it.",
        linkTo: "/",
    },
    {
        image: "/images/vips/vip1.jpg",
        title: "Psalm 3:3",
        description:
            "But thou, O LORD, art a shield for me; my glory, and the lifter up of mine head.",
        linkTo: "/",
    },
    {
        image: "/images/vips/vip2.jpg",
        title: "Psalm 27:1",
        description:
            "The LORD is my light and my salvation; whom shall I fear? The LORD is the strength of my life; of whom shall I be afraid?",
        linkTo: "/",
    },
    {
        image: "/images/vips/vip4.jpg",
        title: "Psalm 37:5",
        description:
            "Commit thy way unto the LORD; trust also in him; and he shall bring it to pass.",
        linkTo: "/",
    },
    {
        image: "/images/vips/vip10.jpg",
        title: "Psalm 125:1",
        description:
            "They that trust in the LORD shall be as mount Zion, which cannot be removed, but abideth for ever.",
        linkTo: "/",
    },
     {
        image: "/images/vips/vip13.jpg",
        title: "Psalm 18:2",
        description:
            "The LORD is my rock, and my fortress, and my deliverer; my God, my strength, in whom I will trust.",
        linkTo: "/",
    },
        {
        image: "/images/vips/vip11.jpg",
        title: "Psalm 138:3",
        description:
            "In the day when I cried thou answeredst me, and strengthenedst me with strength in my soul.",
        linkTo: "/",
    },
        {
        image: "/images/vips/vip15.jpg",
        title: "Psalm 23:4",
        description:
            "Yea, though I walk through the valley of the shadow of death, I will fear no evil: for thou art with me.",
        linkTo: "/",
    },
        {
        image: "/images/vips/vip16.jpg",
        title: "Psalm 28:7",
        description:
            "The LORD is my strength and my shield; my heart trusted in him, and I am helped.",
        linkTo: "/",
    },
     {
        image: "/images/vips/vip19.jpg",
        title: "Psalm 55:22",
        description:
            "Cast thy burden upon the LORD, and he shall sustain thee: he shall never suffer the righteous to be moved.",
        linkTo: "/",
    },
    {
        image: "/images/vips/vip3.jpg",
        title: "Psalm 34:19",
        description:
            "Many are the afflictions of the righteous: but the LORD delivereth him out of them all.",
        linkTo: "/",
    },
    {
        image: "/images/vips/vip5.jpg",
        title: "Psalm 46:1",
        description:
            "God is our refuge and strength, a very present help in trouble.",
        linkTo: "/",
    },
    {
        image: "/images/vips/vip6.jpg",
        title: "Psalm 91:1",
        description:
            "He that dwelleth in the secret place of the most High shall abide under the shadow of the Almighty.",
        linkTo: "/",
    },
    {
        image: "/images/vips/vip7.jpg",
        title: "Psalm 91:11",
        description:
            "For he shall give his angels charge over thee, to keep thee in all thy ways.",
        linkTo: "/",
    },
    {
        image: "/images/vips/vip8.jpg",
        title: "Psalm 103:2–3",
        description:
            "Bless the LORD, O my soul, and forget not all his benefits: Who forgiveth all thine iniquities; who healeth all thy diseases;",
        linkTo: "/",
    },
    {
        image: "/images/vips/vip9.jpg",
        title: "Psalm 121:1–2",
        description:
            "I will lift up mine eyes unto the hills, from whence cometh my help. My help cometh from the LORD, which made heaven and earth.",
        linkTo: "/",
    },
    {
        image: "/images/vips/vip12.jpg",
        title: "Psalm 145:18",
        description:
            "The LORD is nigh unto all them that call upon him, to all that call upon him in truth.",
        linkTo: "/",
    },

    // 🔽 NEW SLIDES
    {
        image: "/images/vips/vip14.jpg",
        title: "Psalm 23:1",
        description:
            "The LORD is my shepherd; I shall not want.",
        linkTo: "/",
    },
    {
        image: "/images/vips/vip17.jpg",
        title: "Psalm 32:8",
        description:
            "I will instruct thee and teach thee in the way which thou shalt go: I will guide thee with mine eye.",
        linkTo: "/",
    },
    {
        image: "/images/vips/vip18.jpg",
        title: "Psalm 40:1–2",
        description:
            "I waited patiently for the LORD; and he inclined unto me, and heard my cry.",
        linkTo: "/",
    },
    {
        image: "/images/vips/vip20.jpg",
        title: "Psalm 66:20",
        description:
            "Blessed be God, which hath not turned away my prayer, nor his mercy from me.",
        linkTo: "/",
    },
    {
        image: "/images/vips/vip21.jpg",
        title: "Psalm 84:11",
        description:
            "For the LORD God is a sun and shield: the LORD will give grace and glory.",
        linkTo: "/",
    },
    {
        image: "/images/vips/vip22.jpg",
        title: "Psalm 107:1",
        description:
            "O give thanks unto the LORD, for he is good: for his mercy endureth for ever.",
        linkTo: "/",
    },
];

    const Watchtowerslides = [
    {
      image:"images/watchTowerImageSlider/watchImageSlider1.jpg",
      title: "The Vision Of The Saints And The Beast By Prophet Kevin N",
      description: "On the dawn of the set day, I was caught up in the...",
      linkTo: "/watchtower",
      scrollToId: "covenant-vision",
    },
    {
      image: "/images/watchTowerImageSlider/watchImageSlider2.jpg",
      title: "The Vision Of the Lion Of Judah By Prophet Kevin N",
      description: "While in prayers, the Heavens were opened upon me and my spirit was caught up in the visions of God...",
      linkTo: "/watchtower",
      scrollToId: "lion-judah-vision",
    },
    {
      image: "/images/watchTowerImageSlider/watchImageSlider3.jpg",
      title: "The Vision About Pornography By Prophet Kevin N",
      description: "While in the place of prayer the Lord spoke to me thus ; My Prophet arise and cry out against the Spirit of Jezebel...",
      linkTo: "/watchtower",
      scrollToId: "pornography-vision",
    },
    {
      image: "/images/watchTowerImageSlider/watchImageSlider4.jpg",
      title: "The Vision Of The Gathering Of The Heavenly Army By Prophet Kevin N",
      description: "I was caught up in the visions of God, and I saw a great gathering of beings, both earthly and heavenly...",
      linkTo: "/watchtower",
      scrollToId: "gathering-army-vision",
    },
    {
      image: "/images/watchTowerImageSlider/watchImageSlider5.jpg",
      title: "The Vision Of The Invation Of The Children Of God By Prophet Kevin N",
      description: "This Morning in-between 3 am to 5 am I saw a vision from the Lord, that unveiled to me the plans of the kingdom of Darkness against the Earth...",
      linkTo: "/watchtower",
      scrollToId: "invasion-children-vision",
    },
    {
      image: "/images/watchTowerImageSlider/watchImageSlider6.jpg",
      title: "The Vision Of The Great Banquet By Prophet Kevin N",
      description: "Today I was caught up in the spirit and, the Lord said to me; Now the Hour has come to gather all men to Me...",
      linkTo: "/watchtower",
      scrollToId: "great-banquet-vision",
    },
    {
      image: "/images/watchTowerImageSlider/watchImageSlider7.jpg",
      title: "The Vision About The Demonic Agenda To Corrupt The Worship Ministry By Prophet Kevin N",
      description: "While I was waiting on the Lord, to know His mind for this time and season, His Word came to me thus...",
      linkTo: "/watchtower",
      scrollToId: "demonic-agenda-vision",
    },
    {
      image: "/images/watchTowerImageSlider/watchImageSlider8.jpg",
      title: "The Vision Of The Mountain Of Transfiguration By Prophet Kevin N",
      description: "While waiting on the Lord and seeking His face for the New Year, I was privileged through the Grace of God to be carried into the...",
      linkTo: "/watchtower",
      scrollToId: "mountain-of-transfiguration-vision",
    },
    {
      image: "/images/watchTowerImageSlider/watchImageSlider9.jpg",
      title: "The Vision Of The Lord Jesus And His Message To The World By Prophet Kevin N",
      description: "By the privilege of Grace, I was carried by the Spirit of God into the visions of God and this is what I saw...",
      linkTo: "/watchtower",
      scrollToId: "lord-jesus-message-vision",
    },
    {
      image: "/images/watchTowerImageSlider/watchImageSlider10.jpg",
      title: "The Vision Of The Lord Jesus Grieved By Prophet Kevin N",
      description: "On the morning of Tuesday, December 26th, I had a deeply troubling vision of the Lord Jesus...",
      linkTo: "/watchtower",
      scrollToId: "lord-jesus-grieved-vision",
    },
    {
      image: "/images/watchTowerImageSlider/watchImageSlider11.jpg",
      title: "The Vision Of The Palm Branches By Prophet Kevin N",
      description: "I was caught up in the visions of God where we were gathered in the assembly of the saints...",
      linkTo: "/watchtower",
      scrollToId: "vision-of-the-palm-branches",
    },
    {
      image: "/images/watchTowerImageSlider/watchImageSlider12.jpg",
      title: "The Vision Of The Evil Birds By Prophet Kevin N",
      description: "On Saturday 27th of April around 2am earthly time, after praying and calling upon the Lord to cause His face to shine upon His people...",
      linkTo: "/watchtower",
      scrollToId: "evil-birds-cover-light-heaven",
    },
    {
      image: "/images/watchTowerImageSlider/watchImageSlider13.jpg",
      title: "An Encounter With Moses And Samuel By Prophet Kevin N",
      description: "On the night of the 18th of March, I had a strange vision in which I saw mysteries and heard unspeakable words, which are...",
      linkTo: "/watchtower",
      scrollToId: "encounter-moses-samuel-book-generations",
    },
    {
      image: "/images/watchTowerImageSlider/watchImageSlider14.jpg",
      title: "My Visit To Heaven By Prophet Kevin N",
      description: "On this ordained night of visitation, I felt a sudden heaviness and I fell asleep as I closed my eyes. Immediately...",
      linkTo: "/watchtower",
      scrollToId: "my-visit-to-heaven-full-version",
    },
    {
      image: "/images/watchTowerImageSlider/watchImageSlider15.jpg",
      title: "The Vision Of The Heavenly Market By Prophet Kevin N",
      description: "This vision came to me in the morning of the 23rd of Nissi (April), after intercession for the Saints, Pastors, and churches...",
      linkTo: "/watchtower",
      scrollToId: "the-vision-of-the-heavenly-market",
    },
    {
      image: "/images/watchTowerImageSlider/watchImageSlider16.jpg",
      title: "Prophecy About The 3 Evil Beings Released Against The Church By Prophet Kevin N",
      description: "A vision the Lord gave me while praying and seeking His face concerning the Church and the nations...",
      linkTo: "/watchtower",
      scrollToId: "three-evil-beings-prophecy",
    },
    {
      image: "/images/watchTowerImageSlider/watchImageSlider17.jpg",
      title: "The Vision Of The Sheep That Mounted Up With Wings By Prophet Kevin N",
      description: "This is the third vision in the morning of the 23rd of Nissi (April)...",
      linkTo: "/watchtower",
      scrollToId: "sheep-with-eagle-wings",
    },
    {
      image: "/images/watchTowerImageSlider/watchImageSlider18.jpg",
      title: "The Vision Of The Great Fruitful Tree By Prophet kevin N",
      description: "I was caught up in the Vision of God, and I saw a Mystery in the Realm of The Spirit...",
      linkTo: "/watchtower",
      scrollToId: "fruitful-tree-vision",
    },
    {
      image: "/images/watchTowerImageSlider/watchImageSlider19.jpg",
      title: "The Vision Of The Sheep, The Evil Birds etc By Prophet Kevin N",
      description: "My spirit was caught up into the visions of God and I saw a great and terrible oracle from the Most High pertaining to the affairs of Men!...",
      linkTo: "/watchtower",
      scrollToId: "sheep-evil-birds-wild-cows-lion",
    },
    {
      image: "/images/watchTowerImageSlider/watchImageSlider20.jpg",
      title: "The Vision Of The Cloud Of Witnesses By Prophet Kevin N",
      description: "The visions of God came upon me while I laid in my bed and thoughts about heavenly things flooded my mind...",
      linkTo: "/watchtower",
      scrollToId: "cloud-of-witnesses",
    },
    {
      image: "/images/watchTowerImageSlider/watchImageSlider21.jpg",
      title: "The Vision About The Northwest And Southwest Region Of Cameroon By Prophet Kevin N",
      description: "The fire in The Northwest and Southwest Regions of Cameroon has been quenched in the Realm of the Spirit...",
      linkTo: "/watchtower",
      scrollToId: "visions-2024-point-2",
    },
    {
      image: "/images/watchTowerImageSlider/watchImageSlider22.jpg",
      title: "The Vision Of 3 Rams Fighting By Prophet Kevin N",
      description: "I saw in the Visions of God 3 rams fighting...",
      linkTo: "/watchtower",
      scrollToId: "visions-2024-point-3",
    },
    {
      image: "/images/watchTowerImageSlider/watchImageSlider23.jpg",
      title: "The Agriculture Sector Will Be The Strength Of The Economy By Prophet Kevin N",
      description: "The agricultural sector will be the strength of the economy and a lot of...",
      linkTo: "/watchtower",
      scrollToId: "visions-2024-point-4",
    },
    {
      image: "/images/watchTowerImageSlider/watchImageSlider24.jpg",
      title: "The Vision Of The Seraphim And The Cherubims By Prophet Kevin N",
      description: "The hand of the Lord carried me in the spirit into the visions of God, and I saw the agenda of the evil one...",
      linkTo: "/watchtower",
      scrollToId: "seraphim-vision",
    },
    {
      image: "/images/watchTowerImageSlider/watchImageSlider25.jpg",
      title: "The Vision About The Dark Beast In The Cloud That Gave Birth To Serpents By Prophet Kevin N",
      description: "On Saturday, the 10th of February 2024, around 6:30am after seeking the Lord, I was caught up in the spirit...",
      linkTo: "/watchtower",
      scrollToId: "dark-beast-vision",
    },
  ];

 return (
    <div className="max-w-10xl pb-6 mx-auto space-y-6">

      {/* ===== MINISTRY SECTIONS GRID ===== */}
      <div className="">
        {[...firstGroup, ...secondGroup, ...extraItems].map((item, idx) => (
          <div
            key={idx}
            className=""
          >
            <Link to={item.link} className="block overflow-hidden">
              <img
                src={item.images[0]}
                alt={item.title}
                className="w-full h-[270px] object-cover rounded transition-transform duration-500 hover:scale-105"
              />
            </Link>

            {/* Title */}
            <h2 className="font-bold text-secondary text-xl tracking-wide">
              {item.title}
            </h2>

            {/* Description */}
            <p className="text-text pl-2 text-sm leading-relaxed font-medium">
              {item.summary}
              
            </p>
            <Link
                to={item.link}
                className="mb-10 w-[130px] pl-2 flex mt-1 text-add font-bold transition"
              >
                Read More  <ArrowRightIcon className="w-10"/>
              </Link>
           
          </div>
        ))}
      </div>

      {/* ===== SCRIPTURE / HERO SLIDER ===== */}
      <div className="rounded-xl overflow-hidden shadow-theme">
        <MainImageSlider slides={Mainslides} />
      </div>

      {/* ===== WORD / ENCOURAGEMENT ===== */}
      <div className="w-full">
        <TextSlider />
      </div>

      {/* ===== VISIONS & WATCHTOWER ===== */}
      <div className="rounded-xl overflow-hidden shadow-theme">
        <ImageSlider slides={Watchtowerslides} />
      </div>

    </div>
  );
};

export default SixLinksGrid;
